"use client";

import {JSX} from "react";
import useAppearOnScroll from "@@/hooks/useAppearsOnScroll";

interface DescriptionProps {
    text: string;
}

export default function Description(props: DescriptionProps): JSX.Element {
    const { text } = props;

    const animatedTxt = useAppearOnScroll<HTMLDivElement>({
        from: "fromBottom",
        duration: 800,
        delay: 0,
        offset: 0
    })

    return (
        <div ref={animatedTxt.ref} className={`px-11 py-5 d-flex justify-center ${animatedTxt.className}`} style={animatedTxt.style}>
            <p className={`mx-width-80 w-100 center fs-1_5 color-blue`} dangerouslySetInnerHTML={{__html: text}}></p>
        </div>
    );
}
